import type {
	ParsedElement,
	ParsedStructuredElement,
} from '../../../../dynamic-layout-parser/types/dynamic-layout-section';

type ElementPosition = 'top' | 'bottom' | 'left' | 'right';

/**
 * Get elements for a specific position, filtering out string elements
 */
export const getElementsForPosition = (
	elements: ParsedElement[],
	position: ElementPosition,
	defaultIndex: number,
): ParsedStructuredElement[] => {
	const result: ParsedStructuredElement[] = [];

	for (let i = 0; i < elements.length; i++) {
		const element = elements[i];
		if (typeof element === 'string') {
			continue;
		}
		if (element.attributes?.pos === position || (i === defaultIndex && !element.attributes?.pos)) {
			result.push(element);
		}
	}

	return result;
};
